import React from 'react';

const BackgroundImg = () => {
  return <div className='fixed w-full h-full bg-water-texture'></div>;
};

export default BackgroundImg;
